import VueRouter from 'vue-router';

import Profile from "../common_components/ProfileForm";
import Dashboard from './components/Dashboard.vue';
import Payment from "./components/Payment";
import Login from '../common_components/Login'
import Main from "./components/Main";
import MemberList from "./components/MemberList";
import StudentDiary from "./components/StudentDiary";
import StudentPayment from "./components/StudentPayment";
import StudentPaymentPackages from "./components/StudentPaymentPackages";
import StudentPaymentHistory from "./components/StudentPaymentHistory";
import Curators from "./components/Curators";
import CuratorsList from "./components/CuratorsList";
import DocumentsList from "./components/DocumentsList";
import PasswordReset from "../common_components/PasswordReset";

let router = new VueRouter({
    mode: 'history',
    base: '/payer',
    routes: [
        {
            path: '/login', name: 'login', component: Login,
            meta: {guest: true}
        },
        {
            path: '/password-reset',
            name: 'password_reset',
            component: PasswordReset,
            meta: {
                guest: true
            }
        },
        {
            path: '', component: Main,
            meta: {requiresAuth: true},
            children: [
                {
                    path: '/', name: 'dashboard', component: Dashboard,
                    meta: {requiresAuth: true},
                },
                {
                    path: '/payment/:child_id', component: StudentPayment,
                    meta: {requiresAuth: true},
                    children: [
                        {
                            path: '', name: 'student_payment', component: StudentPaymentPackages,
                            meta: {requiresAuth: true}
                        },
                        {
                            path: 'history', name: 'history_payment', component: StudentPaymentHistory,
                            meta: {requiresAuth: true}
                        },
                    ]
                },
                {
                    path: '/diary', name: 'diary', component: StudentDiary,
                    meta: {requiresAuth: true},
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: Profile,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '/curators', name: 'curators', component: CuratorsList,
                    meta: {requiresAuth: true}
                },
                {
                    path: '/documents', name: 'documents', component: DocumentsList,
                    meta: {requiresAuth: true}
                }
            ]
        }
        // { path: '/login', name: 'login', component: Login },
        // { path: '/profile', name: 'profile', component: Profile },
    ],

});


export default router;
